export default ({ width }) => 1
